module.exports = __webpack_public_path__ + "img/12.2dc2d997.jpg";